import React from "react";
import { Outlet, Link } from "react-router-dom";
import NavBarCSS from "../css/NavBar";

const NavBar = () => {
  return (
    <div>
      <NavBarCSS>
        <div className="nav">
          <ul className="logo">
            <li>
              <svg
                width="33"
                height="29"
                viewBox="0 0 33 29"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M28.8675 26.7347C28.9351 26.971 28.9688 27.1904 28.9688 27.393C28.9688 27.5618 28.9013 27.7474 28.7663 27.9499C28.665 28.1525 28.53 28.3212 28.3612 28.4563C28.0237 28.7263 27.6524 28.8613 27.2473 28.8613C26.4372 28.8613 25.8971 28.5238 25.627 27.8487L23.146 21.5702H9.32325L6.84223 27.8487C6.60595 28.5238 6.13337 28.8613 5.42451 28.8613C4.6819 28.8613 4.15869 28.5575 3.85489 27.9499C3.75363 27.7474 3.70299 27.5618 3.70299 27.393C3.70299 27.1904 3.73675 26.971 3.80426 26.7347L13.0701 4.0512C13.7114 2.29593 14.4878 1.31703 15.3992 1.11449C15.6692 1.04698 15.973 1.01323 16.3106 1.01323C17.0194 1.01323 17.5427 1.14825 17.8802 1.41829C18.5216 1.99213 19.0616 2.86977 19.5005 4.0512L28.8675 26.7347ZM10.3359 18.9373H22.184L16.26 3.8993L10.3359 18.9373Z"
                  fill="#FDFEF8"
                />
                <path
                  d="M16.5739 4.79663L10.816 19.0871C10.4179 20.2078 9.66338 20.7282 8.55233 20.6482C7.50862 20.5731 6.84828 19.9848 6.57132 18.8831L1.09163 2.76997C1.02999 2.5289 1.00121 2.32401 1.00528 2.15528C1.01017 1.95281 1.04831 1.76963 1.11972 1.60575C1.2248 1.44429 1.3463 1.30091 1.48423 1.17562C1.76009 0.925035 2.08319 0.813066 2.45354 0.839713C3.26158 0.897851 3.75805 1.28852 3.94297 2.01171L8.83616 17.2714L14.487 3.2267C14.8817 2.24099 15.6347 1.7881 16.7457 1.86804C17.8568 1.94798 18.5853 2.50745 18.9312 3.54646L23.6875 18.1878L29.1941 3.82853C29.4806 3.13926 29.9437 2.81763 30.5834 2.86366C30.9874 2.89273 31.3376 3.05315 31.6341 3.34491C31.9306 3.63668 32.0752 3.93442 32.0679 4.23813C32.0614 4.50809 32.0216 4.75876 31.9486 4.99013L25.6612 20.2566C25.3321 21.3147 24.6289 21.8049 23.5515 21.7274C22.4405 21.6475 21.781 21.0254 21.573 19.8611L16.5739 4.79663Z"
                  fill="#FDFEF8"
                />
              </svg>
              AuthWiki
            </li>
          </ul>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>

            <li>
              <Link to="/library">Examples</Link>
            </li>

            <li>
              <Link to="/team">Team</Link>
            </li>
          </ul>

          <ul className="login">
            <li>
              <Link to="/login">Login</Link>
            </li>
            <li>
              <Link id="signup" to="/register">
                Sign Up
              </Link>
            </li>
          </ul>
        </div>
      </NavBarCSS>
      <section>
        <Outlet />
      </section>
    </div>
  );
};

export default NavBar;
